<template>
    <div>
        <div class="card-block-wrap">
            <h3 class="sunb-block-ttl" v-if="payment_accounts.length">Credit Card Information</h3>
            <PaymentCardBillingList
                ref="paymentCardBillingList"
                v-if="payment_accounts.length"
                :paymentAccounts="payment_accounts"
                @destroy="deletePayment"
            >
            </PaymentCardBillingList>

            <div v-show="!payment_accounts.length && !paymentFormOpened">
                <p class="text-intro">You don't have any Subscriptions yet.</p>
                <div class="buttons-bottom buttons-bottom-center">
                    <a
                        href="javascript:void(0)"
                        class="btn btn-yellow"
                        data-toggle="collapse"
                        data-target="#addCardBlock"
                        aria-expanded="false"
                        aria-controls="addCardBlock"
                        @click="showCreateForm"
                    >
                        <i class="fas fa-plus mr-1"></i>Add Card Information
                    </a>
                </div>
            </div>

            <div class="add-card-block">
                <div class="add_link-wrap" v-show="payment_accounts.length && !paymentFormOpened">
                    <a
                        href="javascript:void(0)"
                        class="add_link"
                        data-toggle="collapse"
                        data-target="#addCardBlock"
                        aria-expanded="false"
                        aria-controls="addCardBlock"
                        @click="showCreateForm"
                    >
                        <i class="fas fa-plus mr-2"></i>Add Card Information
                    </a>
                </div>

                <PaymentCardBillingCreate
                    ref="paymentCreate"
                    :countries="input_countries"
                    :states="input_states"
                    @create="createPayment"
                >
                </PaymentCardBillingCreate>
            </div>
        </div>
    </div>
</template>

<script>
    import PaymentCardBillingList from './PaymentCardBillingList';
    import PaymentCardBillingCreate from './PaymentCardBillingCreate';

    export default {
        name: "PaymentMethod",
        components: {
            PaymentCardBillingList,
            PaymentCardBillingCreate,
        },
        props: {
            input_countries: {
                type: Array,
                required: true
            },
            input_states: {
                type: Array,
                required: true
            },
            input_payment_accounts: {
                type: Array,
                required: false
            }
        },
        data() {
            return {
                payment_accounts: this.input_payment_accounts,
                paymentFormOpened: false
            }
        },
        mounted() {

        },
        methods: {
            showCreateForm() {
                this.$refs.paymentCreate.$refs.paymentForm.reset();
                this.paymentFormOpened = true;
            },
            deletePayment(payment_accounts) {
                this.payment_accounts = payment_accounts;
            },
            createPayment(payment_accounts) {
                this.payment_accounts.push(payment_accounts);
                this.paymentFormOpened = false;
            }
        }
    }
</script>
